export const RECENT_SALE_DESTINATIONS = Object.freeze({
  DELIVERY: 'delivery',
  REGISTRATION: 'registration',
  DETAIL: 'detail',
});

export const isCollectingSignatures = transaction =>
  ['sent', 'partially_signed'].includes(
    transaction?.signature_tracking?.status
  ) && Number(transaction?.signature_tracking?.pending_count) > 0;

const isOwnedEditableSale = ({ transaction, currentUserId }) =>
  currentUserId &&
  String(transaction?.manager?.id) === String(currentUserId) &&
  transaction?.permissions?.can_save_draft === true;

export const recentSaleDestination = ({ transaction, currentUserId }) => {
  if (isCollectingSignatures(transaction)) {
    return RECENT_SALE_DESTINATIONS.DELIVERY;
  }

  if (isOwnedEditableSale({ transaction, currentUserId })) {
    return RECENT_SALE_DESTINATIONS.REGISTRATION;
  }

  return RECENT_SALE_DESTINATIONS.DETAIL;
};
